import React, { Component } from 'react';
/** Components */
import { LogoPeque } from '../logo';
import ProfileTabs from '../components/ProfileTabs';
import InfoPerfil from '../components/infoPerfil.js';
/** Services / Utils */
import { showErrorAlert } from '../utils/alerts';
/** CSS */
import defaultUser from '../assets/img/default-user.svg';
import '../components/form.css';
import '../assets/css/profile.css';

export class Profile extends Component {
  constructor(props) {
    super(props);
    this.state = {
      user: '',
      currentUser: {},
      building: '',
      tower: '',
      phone: '',
      email: '',
      apartment: '',
      load: false,
      isResidentLeader: false,
      role: '',
    };
  }

  async componentDidMount() {
    await this.getData();
  }

  async getData() {
    try {
      const user = JSON.parse(localStorage.getItem('user')) || {};
      const spaces = JSON.parse(localStorage.getItem('spaces')) || [];

      const building = spaces[0]?.building || {};
      const apartment = spaces[0]?.apartment || {};

      const isResidentLeader = user.role === 'RESIDENTE_LIDER';

      this.setState({
        user: user.name || '',
        building: building.name || '',
        tower: building.address1 || '',
        phone: user.phone || '',
        email: user.email || '',
        emai: user.email || '',
        apartment: apartment.name || '',
        load: true,
        isResidentLeader,
        photo: user.photo || defaultUser,
        role: user.role || ''
      });
    } catch (error) {
      showErrorAlert('Ups', `Ha ocurrido un error: ${error.message || JSON.stringify(error)}`);
    }
  }




  render() {
    const { load, isResidentLeader } = this.state;

    if (load) {
      return (
        <div className="App bg-blue">
          <div className="container" style={{ paddingBottom: 0 }}>
            <a onClick={this.goBack} className={'btn-back'} />
            <LogoPeque />
            <InfoPerfil
              name={this.state.user}
              building={this.state.building}
              interior={this.state.tower}
              apartament={this.state.apartment}
              phone={this.state.phone}
              email={this.state.email}
              profileImage={this.state.photo || defaultUser}
              role={this.state.role}
            />
            {isResidentLeader ? <ProfileTabs /> : <div />}
          </div>
        </div>
      );
    } else {
      return <div />;
    }
  }

  goBack() {
    window.history.back();
  }
}

export default Profile;
